export default [
    {
        id: 1,
        name_ca: 'Desconegut',
        name_es: 'Desconocido',
        name_en: 'Unknown'
    }, {
        id: 2,
        name_ca: 'Adients',
        name_es: 'Adecuadas',
        name_en: 'Suitable'
    }, {
        id: 3,
        name_ca: 'Insuficients',
        name_es: 'Insuficientes',
        name_en: 'Insufficient'
    }
]





// WEBPACK FOOTER //
// ./src/options/windows_size_and_quantities.js